import React from 'react';
import {
    Box,
    Button,
    Grid,
    Paper,
    TextField,
    Tooltip,
    Typography,
} from '@mui/material';

/**
 * Editor do plano de manutenção preventiva de um modelo. Cada tarefa do catálogo
 * tem dois intervalos, em horas de impressão e em dias, e vence o que chegar
 * primeiro. Deixar os dois em zero equivale a não sugerir aquela tarefa.
 */
function MaintenancePlanFields({ taskTypes, tasks, onChange }) {
    if (!taskTypes || taskTypes.length === 0) {
        return null;
    }

    const intervalOf = (key) => tasks.find((task) => task.task_key === key) || {
        task_key: key,
        interval_hours: 0,
        interval_days: 0,
    };

    const updateInterval = (key, field, rawValue) => {
        const value = Math.max(0, parseInt(rawValue, 10) || 0);
        const others = tasks.filter((task) => task.task_key !== key);
        const current = intervalOf(key);
        onChange([...others, { ...current, [field]: value }]);
    };

    const applyDefaults = () => {
        onChange(taskTypes.map((type) => ({
            task_key: type.key,
            interval_hours: type.default_interval_hours,
            interval_days: type.default_interval_days,
        })));
    };

    return (
        <Paper variant="outlined" sx={{ p: 2, mt: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1, flexWrap: 'wrap' }}>
                <Typography variant="subtitle1" fontWeight={600}>
                    Plano de manutenção preventiva
                </Typography>
                <Tooltip title="Substitui os intervalos pelos padrões do catálogo">
                    <Button size="small" onClick={applyDefaults}>
                        Aplicar padrões
                    </Button>
                </Tooltip>
            </Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Vence o que chegar primeiro: horas de impressão ou dias corridos. Zero nos dois
                campos remove a tarefa da sugestão deste modelo.
            </Typography>

            <Grid container spacing={2}>
                {taskTypes.map((type) => {
                    const interval = intervalOf(type.key);
                    return (
                        <React.Fragment key={type.key}>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body2" fontWeight={600}>
                                    {type.label}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                    {type.description}
                                </Typography>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <TextField
                                    label="Horas de impressão"
                                    fullWidth
                                    size="small"
                                    type="number"
                                    value={interval.interval_hours || ''}
                                    onChange={(event) => updateInterval(type.key, 'interval_hours', event.target.value)}
                                    inputProps={{ min: 0, step: 10 }}
                                />
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <TextField
                                    label="Dias"
                                    fullWidth
                                    size="small"
                                    type="number"
                                    value={interval.interval_days || ''}
                                    onChange={(event) => updateInterval(type.key, 'interval_days', event.target.value)}
                                    inputProps={{ min: 0, step: 5 }}
                                />
                            </Grid>
                        </React.Fragment>
                    );
                })}
            </Grid>
        </Paper>
    );
}

export default MaintenancePlanFields;
